import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AuthorizationError {
  message: string;
  endpoint: string;
  provider: string;
  timestamp: string;
}

interface AuthorizationErrorContextType {
  authError: AuthorizationError | null;
  setAuthError: (error: AuthorizationError | null) => void;
  clearAuthError: () => void;
}

const AuthorizationErrorContext = createContext<AuthorizationErrorContextType | undefined>(undefined);

export const useAuthorizationError = () => {
  const context = useContext(AuthorizationErrorContext);
  if (!context) {
    throw new Error('useAuthorizationError must be used within an AuthorizationErrorProvider');
  }
  return context;
};

interface AuthorizationErrorProviderProps {
  children: ReactNode;
}

export const AuthorizationErrorProvider: React.FC<AuthorizationErrorProviderProps> = ({ children }) => {
  const [authError, setAuthError] = useState<AuthorizationError | null>(null);

  const clearAuthError = () => {
    setAuthError(null);
  };

  return (
    <AuthorizationErrorContext.Provider value={{ authError, setAuthError, clearAuthError }}>
      {children}
    </AuthorizationErrorContext.Provider>
  );
}; 